import { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import { useLanguage } from '../../../context/LanguageContext';
import FilterList from './filter';
import type { PathFilterItem } from './filter';

const COLLECTION_KEYS: Record<string, string> = {
  accessoires: 'collections.accessoires',
  bespoke: 'collections.bespoke',
  studio: 'collections.studio',
};

export default function Collections() {
  const { t } = useLanguage();
  const [collections, setCollections] = useState<PathFilterItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCollections() {
      try {
        const { data, error } = await supabase
          .from('categories')
          .select('id, name, slug')
          .eq('is_active', true)
          .order('name', { ascending: true });

        if (error) throw error;

        const list: PathFilterItem[] = [{ title: t('collections.all'), path: '/collections' }];
        if (data) {
          data.forEach((cat: { id: string; name: string; slug: string }) => {
            const labelKey = COLLECTION_KEYS[cat.slug];
            list.push({
              title: labelKey ? t(labelKey) : cat.name,
              path: `/collections/${cat.slug}`,
            });
          });
        }
        setCollections(list);
      } catch (err) {
        console.error('Error loading collections:', err);
        setCollections([{ title: t('collections.all'), path: '/collections' }]);
      } finally {
        setLoading(false);
      }
    }
    loadCollections();
  }, [t]);

  if (loading) {
    return (
      <div className="mb-3 h-4 w-5/6 animate-pulse rounded-sm bg-neutral-400 dark:bg-neutral-700" />
    );
  }

  return <FilterList list={collections} title={t('collections.title')} />;
}
